import type { FeedbackFormOptionConfig } from "@medbillai/ui";

export const REFERRAL_SOURCE_OPTIONS: FeedbackFormOptionConfig[] = [
  { label: "Facebook", image: "/static/fb-icon.webp" },
  { label: "Instagram", image: "/static/instagram-icon.webp" },
  { label: "Apple App Store", image: "/static/app-store-icon.webp" },
  { label: "Google search", image: "/static/google-icon.webp" },
  { label: "Friend, family or colleague", emoji: "🧑‍🤝‍🧑" },
  { label: "Other", emoji: "✏️" },
] as const;
